import React from 'react';

import './Order.sass';

import cx from 'classnames';
import ChannelPrice from '../../containers/channelUtils/ChannelPrice';
import ChannelLink from '../../containers/channelUtils/ChannelLink';
import CartProduct from '../cartProduct/CartProduct';
import Pricing from '../pricing/Pricing';
import ProductVariantContainer from '../productVariants/ProductVariantContainer';
import StarRating from '../reviews/stars/StarRating';
import Tags from '../tags/Tags';
import FormatDate from '../dates/FormatDate';
import CurrentTimezone from '../dates/CurrentTimezone';
import {FormattedMessage} from 'react-intl';

export default function Order({aftercheckout, order, footer}) {
  // Reviews the user has already left for this order, keyed by product code.
  // Present only on the profile orders list; absent elsewhere (→ no stars).
  const reviewByCode = (order.productReviews || []).reduce((acc, review) => {
    acc[review.productCode] = review;
    return acc;
  }, {});
  const reviewLink = `/order/${order.tokenValue}/review`;

  return (
    <div className={cx("order", aftercheckout && "order--aftercheckout")}>
      <div className="order__header">
        <span className="order__number">
          <FormattedMessage id="page.order.number"/>{order.number}
        </span>
        <span className="order__price">
          <Pricing
            channel={order.channelCode}
            value={order.total}
            originalValue={order.promotionTotal ? order.total - order.promotionTotal : undefined}
          />
        </span>
      </div>
      <div className="order__content">
        {order.items.map(item => {
          const productCode = item.variant && item.variant.product && item.variant.product.code;
          const review = productCode && reviewByCode[productCode];

          return (
            <div key={item.id} className="order__item">
              <div className="order__item-description">
                {Boolean(item.event) && Boolean(item.eventOccurrence) && (
                  <div className="order__item-time">
                    <FormatDate
                      date={item.eventOccurrence}
                      format="DD MMM, HH:mm"
                    />
                    {' '}
                    (<CurrentTimezone/>)
                  </div>
                )}
                <div className="order__item-name">
                  {CartProduct.getItemTitle(item, order.createdFromAdmin)}
                </div>
                <div className="order__item-options">
                  <Tags tags={ProductVariantContainer.describeProductChoice(item)}/>
                </div>
              </div>

              <div className="order__item-right">
                {review && (
                  <ChannelLink
                    className="order__item-rating"
                    to={reviewLink}
                    aria-label="Your review"
                  >
                    <StarRating value={review.rating}/>
                  </ChannelLink>
                )}

                <ChannelPrice
                  className="order__item-price"
                  channel={order.channelCode}
                  price={item.total}
                />
              </div>
            </div>
          );
        })}
      </div>

      {footer && (
        <div className="order__footer">{footer}</div>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/order/Order.js